const experimentConfig = {
  experimentName: "Experiment Name",
  controlVariationName: "Control Variation",
  testVariationName: "Test Variation"
};

export { experimentConfig };
//# sourceMappingURL=src-config-experiment-config.js.map
